import { AccountDetails, EMPTY_USER, loggedInUserInfo } from "./types";

let currentUser: loggedInUserInfo | null = null;
let currentAccountId: string | null = null; 

export async function setCurrentSession() {
  try {
    const response = await fetch(`${import.meta.env.VITE_JAVA_SERVICE_ACCOUNTS_BASE}auth/me`, {
      method: 'GET',
      credentials: 'include' // This ensures cookies are sent with the request
    });
    
    if (response.ok) {
      const userData = await response.json();
      const lowercasedEmail = typeof userData.email === "string" ? userData.email?.toLowerCase() : userData.email;
      
      currentUser = {
        id: userData?.profileOrgId as string,
        name: userData?.name as string,
        email: lowercasedEmail as string,
        profilePicture: userData?.pictureUrl,
        accessToken: '',
      };


      const accountDetails: AccountDetails = {
        email: lowercasedEmail,
        accountId: userData.accountId,
        orgId: userData.orgId,
        profileOrgId: userData.profileOrgId,
        name: userData.name,
        roleId: userData.roleId,
        isActive: userData.isActive,
        isExternalUser: userData.isExternalUser,
        isImpersonator: userData.isImpersonator,
        pictureUrl: userData.pictureUrl,
      };
      currentAccountId = userData.accountId;
      return { accountDetails };
    } else {
      if (response.status === 403) {
        throw new Error(`Authentication API 403 error: ${response.status}`);
      } else {
        throw new Error(`Authentication API error: ${response.status}`);
      }
    }
  } catch (err) {
    console.error('Authentication failed:', err);
    clearCurrentSession();
    throw err;
  }
}
export const accountId = (): string => {
  return currentAccountId || '';
}

export const getUserAttributes = (): loggedInUserInfo => {
  return currentUser ?? EMPTY_USER;
};

export async function refreshCurrentSession() {
  try {
    // For cookie-based auth, we validate the session by calling the auth API
    await setCurrentSession();
  } catch (err) {
    console.error('Session refresh failed:', err);
    clearCurrentSession();
  }
}


export function clearCurrentSession() {
  currentUser = null;
}